import { IToDoItem } from './models';
import { ToDoWrapper } from './styles';
import ToDoSection from './to-do-section';

interface IProps {
    toDoItems: IToDoItem[],
    complianceItems: IToDoItem[],
    hideEmptyItems?: boolean
}

const OpoToDo = ({ toDoItems, complianceItems, hideEmptyItems = true }: IProps) => (
    <ToDoWrapper>
        <ToDoSection
            title='To-Do'
            subtitle='Urgent items'
            variant='urgent'
            items={toDoItems}
            hideEmptyItems={hideEmptyItems}
            emptyMessage='At this time, there are no urgent items'
        />

        <ToDoSection
            title='Compliance'
            subtitle='Compliance items'
            variant='compliance'
            items={complianceItems}
            hideEmptyItems={hideEmptyItems}
            emptyMessage='At this time, there are no compliance items'
        />
    </ToDoWrapper>
);

export default OpoToDo;
